import IGeofence from "@/models/dto/IGeofence";
import { Feature } from "ol";
import { Geometry, Point, Polygon } from "ol/geom";
import { Fill, Icon, Stroke, Text } from "ol/style";
import Style from "ol/style/Style";
import BaseFeature from "./base.feature";
import GeofenceUtil from "@/utils/geofence.util";

export default class PolygonGeofenceFeature extends BaseFeature {

    geofence: IGeofence

    constructor(geofence: IGeofence) {
        super();
        this.geofence = geofence
    }

    getFeature(): Feature<Polygon> {
        const polygonGeom = GeofenceUtil.parsePolygonGeometry(this.geofence.area);
        const polygonFeature = new Feature({
            type: 'geofence',
            geometry: polygonGeom
        });
        return polygonFeature
    }

    getCenterFeature(): Feature<Geometry> {
        const center = this.getFeature().getGeometry()!.getInteriorPoint()
        const iconFeature = new Feature({
            type: 'geofence',
            geometry: new Point(center.getCoordinates())
        });
        iconFeature.setStyle(this.getStyle())
        return iconFeature
    }

    getStyle(): Style {
        return new Style({
            stroke: new Stroke({
                color: '#6610f2',
                width: 3
            }),
            fill: new Fill({
                color: 'rgba(128, 0, 128, 0.1)'
            }),
            image: new Icon(({
                anchor: [0.5, 0.5],
                scale: 0.7,
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                crossOrigin: 'anonymous',
                src: require("@/assets/img/geofences/" + (this.geofence.attributes.icon || '0') + ".png")
            })),
            text: new Text({
                font: 'bold 20px Changa',
                overflow: true,
                text: this.geofence.name,
                fill: new Fill({
                    color: '#6610f2'
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 2
                }),
                offsetY: 28,
                scale: 1
            })
        });
    }

    isValid(): boolean {
        return true
    }

}